module.exports = __webpack_public_path__ + "img/vertical_7_4_7042.cd0982bf.png";